export const DEFAULT_PENALTY = 0;

export const THEMEOPTIONS = [
  { label: 'Claro', value: 'false' },
  { label: 'Escuro', value: 'true' }
];
